<script setup lang="ts">
import { toRefs, ref, onMounted } from 'vue';
import Dialog from 'primevue/dialog';
import { EMIT } from '@/enum';
import { useStudentReferralStore } from '@/store';
import { StudentClinicianInterface } from '@/types';

interface PropsInterface {
  ids?: number[];
}

const emit = defineEmits<{
  (e: EMIT.CANCEL): void;
  (e: EMIT.SAVE, serviceProvider: StudentClinicianInterface): void;
}>();

const props = defineProps<PropsInterface>();

const { ids } = toRefs(props);

const serviceProvider = ref();

const modalVisible = ref(true);

const referralStore = useStudentReferralStore();

onMounted(() => {
  if (ids.value) referralStore.getCliniciansAvailableForReferral(ids.value);
});

const save = () => {
  emit(EMIT.SAVE, serviceProvider.value);
  modalVisible.value = false;
};

const cancel = () => {
  emit(EMIT.CANCEL);
  modalVisible.value = false;
  return;
};
</script>

<template>
  <Dialog
    v-model:visible="modalVisible"
    :draggable="false"
    class="dialog__container assign__dialog__container"
    :closable="false"
    :modal="true"
    @hide="cancel"
  >
    <template #header>
      <h2 v-text="'Assign to Service Provider'" />
    </template>
    <template #default>
      <div v-if="referralStore.serviceProviders?.length">
        <label for="service_provider">Service Provider</label>
        <Dropdown
          v-model="serviceProvider"
          type="secondary"
          :options="referralStore.serviceProviders"
          option-label="full_name"
          placeholder="Select Service Provider"
        />
      </div>
      <span v-else>Sorry there are no Service Providers.</span>
    </template>
    <template #footer>
      <AppButton id="cancel_service_btn" type="secondary" text="Cancel" @click="cancel" />
      <AppButton id="save_service_btn" type="primary" text="Assign" @click="save" />
    </template>
  </Dialog>
</template>

<style scoped lang="scss">
.assign__dialog__container {
  width: 396px !important;

  .p-dialog-header,
  .p-dialog-content {
    background: white !important;
  }

  .p-dialog-header {
    padding: 15px !important;
  }

  .p-dialog-content {
    padding: 5px 15px 15px 15px !important;
  }

  .p-dialog-footer {
    padding: 5px 10px 15px 5px !important;
  }
}
</style>
